import React from "react";

function ExclamationIcon() {
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C12.4184 0 16 3.5824 16 8C16 12.4176 12.4184 16 8 16C3.5816 16 0 12.4176 0 8C0 3.5824 3.5816 0 8 0ZM8 1.3336C4.324 1.3336 1.3336 4.324 1.3336 8C1.3336 11.676 4.324 14.6664 8 14.6664C11.676 14.6664 14.6664 11.676 14.6664 8C14.6664 4.324 11.676 1.3336 8 1.3336ZM7.9992 10.0016C8.21116 10.0016 8.41444 10.0858 8.56432 10.2357C8.7142 10.3856 8.7984 10.5888 8.7984 10.8008C8.7984 11.0128 8.7142 11.216 8.56432 11.3659C8.41444 11.5158 8.21116 11.6 7.9992 11.6C7.78724 11.6 7.58396 11.5158 7.43408 11.3659C7.2842 11.216 7.2 11.0128 7.2 10.8008C7.2 10.5888 7.2842 10.3856 7.43408 10.2357C7.58396 10.0858 7.78724 10.0016 7.9992 10.0016ZM7.9952 4C8.14033 3.99981 8.2806 4.05223 8.39004 4.14755C8.49948 4.24287 8.57066 4.37462 8.5904 4.5184L8.596 4.5992L8.5992 8.2008C8.59936 8.35289 8.54175 8.49936 8.43803 8.6106C8.33431 8.72183 8.19222 8.78953 8.0405 8.8C7.88877 8.81046 7.73873 8.76292 7.62072 8.66698C7.5027 8.57104 7.42553 8.43387 7.4048 8.2832L7.3992 8.2016L7.396 4.6008C7.3959 4.52194 7.41134 4.44383 7.44144 4.37094C7.47155 4.29806 7.51573 4.23182 7.57145 4.17602C7.62718 4.12022 7.69336 4.07595 7.7662 4.04575C7.83905 4.01555 7.91634 4 7.9952 4Z"
      fill="#F44336"
    />
  </svg>;
}

export default ExclamationIcon;
